const ReportLoding = ({ pageSize }: { pageSize: any }) => {
  const colWidths = ["w-8", "w-24", "w-20", "w-16", "w-16", "w-16", "w-16", "w-16"];

  return (
    <>
      {Array.from({ length: Math.min(pageSize, 20) }).map((_, index) => (
        <tr
          key={index}
          className="animate-pulse"
          style={{
            background:
              index % 2 === 0 ? "rgba(255,255,255,0.01)" : "transparent",
            borderBottom: "1px solid rgba(255,255,255,0.04)",
          }}
        >
          {colWidths.map((w, colIdx) => (
            <td key={colIdx} className="px-3 sm:px-4 py-3">
              <div
                className={`h-4 ${w} rounded-md`}
                style={{ background: "rgba(255,255,255,0.06)" }}
              />
            </td>
          ))}
        </tr>
      ))}
    </>
  );
};

export default ReportLoding;
